import {
  COLLECTION_RANK_IDS,
  COLLECTION_RANK_NAMES,
  FixtureStatusId,
} from '@/service/constants';

export enum IssueSeverity {
  None,
  Medium,
  Critical,
}

export enum Issue {
  SCORER_DISCONNECTED = 1,
  OUTDATED_APP_VERSION = 2,
  COLL_STAT_SUSPENDED = 3,
  DATA_REVIEW_UNDERWAY = 4,
  PLAY_STOPPED = 5,
  COLLECTION_STATUS = 6,
  FLAGS_UNCONFIRMED = 7,
  MATCH_NOT_LIVE = 8,
  NO_COMMENT_ON_ACTIONS = 9,
  GDS_NOT_ACKNOWLEDGED_PRESENCE = 10,
  MARKET_CLOSED = 11,
}

export interface SummaryIssue {
  issueId: Issue;
  totalIssuesCount: number;
}

export interface RequiresAction {
  id: IssueSeverity;
  name: string;
  displayName: string;
}

export interface FixtureIssue {
  id: Issue;
  name: string;
  reportedOn: Date;
  requiresAction: RequiresAction;
}

export interface CollectionRank {
  id: COLLECTION_RANK_IDS;
  name: string;
  displayName: string;
}

export interface Scorer {
  userId: string;
  appVersion: string;
  appType: string;
  isConnected: boolean;
  fullName: string;
  collectionId: string;
}

export interface Resolver {
  fullName: string;
  resolvedOn: null | string;
  userId: string;
}

export interface Collection {
  fixtureId: string;
  collectionId: string;
  name: string;
  rank: COLLECTION_RANK_NAMES;
  competitionName: string;
  workstationName: string;
  supervisorName: string;
  supervisorId: string | null;
  latestState: LatestState;
  sportId: number;
  startTimeUtc: string | null;
  statuses: Status;
  scorers: Scorer[];
  resolver: Resolver | null;
  issues: FixtureIssue[];
}

export interface LatestState {
  period: number | null;
  isClockPaused: boolean | null;
  clockTime: string | null;
}

export interface Status {
  collectionId: string;
  collectionStatus: number;
  fixtureStatus: FixtureStatusId;
}

export interface Pagination {
  page: number;
  limit: number;
  results: number;
}

export interface FixturesWithIncidents {
  collections: {
    data: Collection[];
    pagination: Pagination;
  };
  summary: SummaryIssue[];
}

export interface FilterWithStringId {
  id: string;
  name: string;
}

export interface FilterWithNumberId {
  id: number;
  name: string;
}
